// Dependencias generales
import React from "react";
import { useEffect } from 'react';

import Condition from '../../components/Rules/Condition'


// DASHBOARD
const ConditionsList = (params) => {
  
  useEffect(() => {   
    console.log("Listado de condiciones cargado correctamente.")
  },[params]);

  function gestionarVisibilidadAcordeonesCondiciones(idAcordeonPulsado){
    
    for(var x=0;x < params.objRule.Rule.conditions.length; x++){    
      if(idAcordeonPulsado !== "detalleCondicion"+(x+1)){        
        document.getElementById("detalleCondicion"+(x+1)).removeAttribute("open")
      }
    }
    
  }

  const listConditions = params.objRule.Rule.conditions.map((condition) =>

  <React.Fragment key={condition.conditionId}>

    <Condition 
      conditionInfo={condition} 
      objDatosDashboard={params.objDatosDashboard} 
      objDatosDispositivos={params.objDatosDispositivos} 
      eliminarCondicion={params.eliminarCondicion} 
      gestionarVisibilidadAcordeonesCondiciones={gestionarVisibilidadAcordeonesCondiciones}
      mostrarOcultarBloqueResumen={params.mostrarOcultarBloqueResumen}
      visibilidadModalFiltradoDatos={params.visibilidadModalFiltradoDatos}
      setObjRuleElementSelector={params.setObjRuleElementSelector}
    /> 

  </React.Fragment>
  );    


  return (        
    <>{listConditions}</>
  )
}

export default ConditionsList